import { gql } from '@apollo/client';

export const REMOVE_ARREST_FROM_INCIDENT = gql`
mutation removeArrestFromIncident($input: RemoveArrestFromIncidentInput!) {
  removeArrestFromIncident(input: $input) {
    __typename
    clientMutationId
    errors
    incidentArrestUuid
  }
}
`
